var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"screenDom",staticClass:"box"},[_c('scale-box',{staticStyle:{"transition":"unset"},attrs:{"width":1920,"height":1080,"bgc":"transparent","delay":100},on:{"scaleChange":_vm.handleScaleChange}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }